'use strict'
import numeral from 'numeral'

const PriceFormatter = (value) => {
  let format = '0'

  if (value <= 0) {
    format = '0'
  } else if (value < 10) {
    format = '0.00'
  } else if (value < 100) {
    format = '0.0'
  } else if (value < 1000) {
    format = '0'
  } else if (value < 10000) {
    format = '0.00a'
  } else if (value < 100000) {
    format = '0.0a'
  } else if (value < 1000000) {
    format = '0a'
  }

  return numeral(value).format(`$${format}`)
}

export default PriceFormatter
